<template>
<div class="tips-content">
  <Tooltip
    v-if="flag"
    :content="txtInfo"
    placement="top"
    theme="dark"
    :disabled="isDisabled"
    style="width: 100%;"
  >
    <div class="wordnowrap" @mouseenter="isShowTooltip">{{ txtInfo }}</div>
  </Tooltip>
</div>
</template>

<script>
export default {
  name:"tooltip",
  props: {
    txtInfo:''
  },
  data() {
    return {
      isDisabled: false,
      flag:false
    };
  },
  watch:{
    txtInfo:{
      handler(val){
        if(val){
          this.flag = true
        }else{
          this.flag = false
        }
      },
      immediate: true
    }
  },
  methods: {
    isShowTooltip(e) {
      let clientWidth = e.target.clientWidth,
        scrollWidth = e.target.scrollWidth;
      if (scrollWidth > clientWidth) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tips-content {
  width: 100%;
}
.wordnowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .ivu-tooltip-inner{
    white-space: normal;
  }
</style>
